/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { PublicWarningSettings } from '../types';
// @ts-ignore
import type { UpdatePublicWarningSettingsBody } from '../types';
// @ts-ignore
import type { ValidationError } from '../types';
/**
 * PublicWarningSettingsApi - axios parameter creator
 * @export
 */
export const PublicWarningSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get public warning settings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicWarningSettingsForDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getPublicWarningSettingsForDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/public_warning_settings`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update public warning settings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {UpdatePublicWarningSettingsBody} [updatePublicWarningSettingsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublicWarningSettings: async (dashboardId: string, updatePublicWarningSettingsBody?: UpdatePublicWarningSettingsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('updatePublicWarningSettings', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/public_warning_settings`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePublicWarningSettingsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicWarningSettingsApi - functional programming interface
 * @export
 */
export const PublicWarningSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicWarningSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get public warning settings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicWarningSettingsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicWarningSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicWarningSettingsForDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicWarningSettingsApi.getPublicWarningSettingsForDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update public warning settings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {UpdatePublicWarningSettingsBody} [updatePublicWarningSettingsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePublicWarningSettings(dashboardId: string, updatePublicWarningSettingsBody?: UpdatePublicWarningSettingsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicWarningSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePublicWarningSettings(dashboardId, updatePublicWarningSettingsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicWarningSettingsApi.updatePublicWarningSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublicWarningSettingsApi - factory interface
 * @export
 */
export const PublicWarningSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicWarningSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get public warning settings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicWarningSettingsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<PublicWarningSettings> {
            return localVarFp.getPublicWarningSettingsForDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update public warning settings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {UpdatePublicWarningSettingsBody} [updatePublicWarningSettingsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublicWarningSettings(dashboardId: string, updatePublicWarningSettingsBody?: UpdatePublicWarningSettingsBody, options?: RawAxiosRequestConfig): AxiosPromise<PublicWarningSettings> {
            return localVarFp.updatePublicWarningSettings(dashboardId, updatePublicWarningSettingsBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicWarningSettingsApi - object-oriented interface
 * @export
 * @class PublicWarningSettingsApi
 * @extends {BaseAPI}
 */
export class PublicWarningSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Get public warning settings for Dashboard by ID
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicWarningSettingsApi
     */
    public getPublicWarningSettingsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return PublicWarningSettingsApiFp(this.configuration).getPublicWarningSettingsForDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update public warning settings for Dashboard by ID
     * @param {string} dashboardId 
     * @param {UpdatePublicWarningSettingsBody} [updatePublicWarningSettingsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicWarningSettingsApi
     */
    public updatePublicWarningSettings(dashboardId: string, updatePublicWarningSettingsBody?: UpdatePublicWarningSettingsBody, options?: RawAxiosRequestConfig) {
        return PublicWarningSettingsApiFp(this.configuration).updatePublicWarningSettings(dashboardId, updatePublicWarningSettingsBody, options).then((request) => request(this.axios, this.basePath));
    }
}

